(function () {
	// Helper function for slideDown animation
	const slideDown = (element, duration = 300) => {
		element.style.overflow = 'hidden';
		element.style.display = 'block';
		const height = element.scrollHeight;
		element.style.height = '0px';
		element.offsetHeight; // force reflow
		element.style.transition = `height ${duration}ms ease`;
		element.style.height = height + 'px';
		setTimeout(() => {
			element.style.height = '';
			element.style.overflow = '';
			element.style.transition = '';
		}, duration);
	};

	// Helper function for slideUp animation
	const slideUp = (element, duration = 300) => {
		element.style.overflow = 'hidden';
		element.style.height = element.scrollHeight + 'px';
		element.offsetHeight; // force reflow
		element.style.transition = `height ${duration}ms ease`;
		element.style.height = '0px';
		setTimeout(() => {
			element.style.display = 'none';
			element.style.height = '';
			element.style.overflow = '';
			element.style.transition = '';
		}, duration);
	};

	const initCollapsibleContent = () => {
		document.querySelectorAll(".collapsible-content__toggle").forEach(toggle => {
			// Remove existing listeners by cloning
			const newToggle = toggle.cloneNode(true);
			toggle.parentNode.replaceChild(newToggle, toggle);

			newToggle.addEventListener("click", function () {
				const parent = this.parentElement;
				const answer = this.nextElementSibling;

				if (!parent.classList.contains("active")) {
					// Close other active items
					const items = this.closest(".collapsible-content__items");
					if (items) {
						items.querySelectorAll(".collapsible-content__item.active").forEach(activeItem => {
							activeItem.classList.remove("active");
							const activeAnswer = activeItem.querySelector(".collapsible-content__answer");
							if (activeAnswer) slideUp(activeAnswer, 300);
						});
					}
					parent.classList.add("active");
					slideDown(answer, 300);
				} else {
					parent.classList.remove("active");
					slideUp(answer, 300);
				}
			});
		});

		document.querySelectorAll(".collapsible-content__item").forEach(item => {
			item.addEventListener("mouseenter", function () {
				this.classList.remove("collapsible-content__item--opacity");
				Array.from(this.parentElement.children).filter(el => el !== this).forEach(sibling => {
					sibling.classList.add("collapsible-content__item--opacity");
				});
			});

			item.addEventListener("mouseleave", function () {
				Array.from(this.parentElement.children).filter(el => el !== this).forEach(sibling => {
					sibling.classList.remove("collapsible-content__item--opacity");
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
